import * as React from "react";
const SvgMarkUnreadChatAlt = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 3,
  r: 3,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 8V6h9.03a4.906 4.906 0 0 1-.92-4H2.01L2 22l4-4h16V6.97C21.16 7.61 20.13 8 19 8H6zm8 6H6v-2h8v2zm4-3H6V9h12v2z",
  fill: "currentColor"
}));
export default SvgMarkUnreadChatAlt;